//Use this class as a model for future services.
//No Custom Repository Class is required 

import { AppState } from "../entities/entities";
import { EntityManager, Repository } from "aurelia-orm";
import { autoinject, LogManager } from 'aurelia-framework';

@autoinject()
export class AppStateService {
    clearData(): any {
		this.appStateEntities = null;
    }

	className: string = 'Dashboard'
	logger = LogManager.getLogger(this.className);

	appStateEntities: Array<AppState>;

	getNew(): any {
		return this.repository.getNewEntity();
	}

	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(AppState);
	}

	//Get All App State for the entire app upfront so there is no slow creating forms.
	//This is an array of arrays.
	//async getAppState() {
	//	this.appStateEntities = await this.repository.find();
	//}
	
	async getAppStateByClassName(objectName: string) {

		return this.appStateEntities = await this.repository.find({ objectName: objectName });
	}

	async setAppState(className: string, instance: object) {
		this.logger.info(`setting app state for ${className}`)
		

		const appStateEntities = await this.getAppStateByClassName(className);

		for (let appState of appStateEntities) {
			if (appState.isObject) {
				appState.value = JSON.parse(appState.value);
			}
			instance[appState.propertyName] = appState.value;
		}

	}

	saveState(objectName: string, propertyName: string, value: any, isObject?:boolean): any {
		this.logger.info(`Saving state for ${objectName}.${propertyName} `);

		if (isObject) {
			value = JSON.stringify(value);
		}

		let appState:AppState = this.getNew();
		appState.objectName = objectName;
		appState.propertyName = propertyName;
		appState.value = value;
		appState.isObject = isObject;

		appState.save();
		
		//this.repository.findPath('appState/updateAppState', { objectName: objectName, propertyName: propertyName, value: value, isObject: isObject });
		

	}
	




}